import { FilterSimpleSelect } from "components/FilterSimpleSelect";
import FilterToggle from "components/FilterToggle";
import { useField } from "lib/form";
import React, { useState } from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";
import { mq, device } from "lib/media-query";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

const { format } = Intl.NumberFormat("nl-NL", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
});

export const MotorinhoudFilter = ({ condensed }) => {
    const filterOptions = useFilter("motorinhoud");
    const [minValue, , onMinChange] = useField("minimaleMotorinhoud");
    const [maxValue, , onMaxChange] = useField("maximaleMotorinhoud");
    const [unit, setUnit] = useState("cc");

    const minOptionsValue = filterOptions[0];
    const maxOptionsValue = filterOptions[filterOptions.length - 1];

    const minOptions =
        filterOptions
            .filter((v) => v <= (maxValue[0] || maxOptionsValue))
            .map((v) => ({
                id: v.toString(),
                displayName: `${format(unit === "liter" ? v / 1000 : v)} ${unit}`
            })) || [];

    const maxOptions =
        filterOptions
            .filter((v) => v >= (minValue[0] || minOptionsValue))
            .map((v) => ({
                id: v.toString(),
                displayName: `${format(unit === "liter" ? v / 1000 : v)} ${unit}`
            })) || [];

    return (
        <Grid condensed={condensed}>
            <div>
                <FilterSimpleSelect
                    filterId="filter-motorinhoud-min"
                    options={minOptions}
                    value={minValue}
                    handleChange={(_, value) => onMinChange(value)}
                    datalayerKey="motorinhoud.min"
                    helpText="Van"
                    classes="left"
                />
                <FilterSimpleSelect
                    filterId="filter-motorinhoud-max"
                    options={maxOptions}
                    value={maxValue}
                    handleChange={(_, value) => onMaxChange(value)}
                    datalayerKey="motorinhoud.max"
                    helpText="Tot"
                    classes="right"
                />
            </div>
            <div>
                <FilterToggle
                    handleChange={() => setUnit(unit === "cc" ? "liter" : "cc")}
                    classes="mt-3 mb-2"
                    selected={unit}
                    options={["cc", "liter"]}
                />
            </div>
        </Grid>
    );
};
